module.exports = __webpack_public_path__ + "static/media/marine.af6974e6.png";